import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Suspense, lazy, useEffect } from 'react'
import ErrorBoundary from './components/ErrorBoundary'
import LoadingSpinner from './components/LoadingSpinner'
import FloatingNavigation from './components/FloatingNavigation'
import NotFoundPage from './components/NotFoundPage'
import Footer from './components/Footer'
import { initGA, trackWebVitals, startTimeTracking } from './utils/analytics'

// Lazy load heavy components for better bundle splitting
const HeroSection = lazy(() => import('./components/HeroSection'))
const BioSection = lazy(() => import('./components/BioSection'))
const StorySection = lazy(() => import('./components/StorySection'))
const ProjectsSection = lazy(() => import('./components/VenturesSection'))
const OverUnitySection = lazy(() => import('./components/OverUnitySection'))
const InsightsSection = lazy(() => import('./components/InsightsSection'))
const OfferSection = lazy(() => import('./components/OfferSection'))
const ContactSection = lazy(() => import('./components/ContactSection'))

function App() {
  useEffect(() => {
    // Initialize analytics
    initGA()
    trackWebVitals()
    startTimeTracking()
  }, [])

  return (
    <ErrorBoundary>
      <Router>
        <div className="relative min-h-screen bg-space-black text-light-gray">
          {/* Background constellation effect */}
          <div className="fixed inset-0 overflow-hidden pointer-events-none">
            <div className="constellation-background" />
          </div>
          
          {/* Floating navigation */}
          <FloatingNavigation />
          
          {/* Main content */}
          <Suspense fallback={
            <div className="min-h-screen flex items-center justify-center">
              <LoadingSpinner size="lg" text="Initializing constellation..." />
            </div>
          }>
            <Routes>
              <Route path="/" element={
                <>
                  <main id="main-content">
                    <HeroSection />
                    <BioSection />
                    <StorySection />
                    <ProjectsSection />
                    <OverUnitySection />
                    <InsightsSection />
                    <OfferSection />
                    <ContactSection />
                  </main>
                  <Footer />
                </>
              } />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </div>
      </Router>
    </ErrorBoundary>
  )
}

export default App 